import { useRef } from "react"
import { useNavigate } from "react-router-dom"

import Style from "./style"

import DefaultButton from "shared/ui/DefaultButton"
import DefaultInput from "shared/ui/DefaultInput"

import usePostAdminLogin from "entity/auth/usePostAdminLogin"

const LoginAdmin = () => {
    const navigate = useNavigate()

    const idRef = useRef()
    const pwRef = useRef()

    const [postLoginEvent, enterLoginEvent] = usePostAdminLogin(idRef, pwRef)

    return (
        <Style.Wrapper>
            <Style.ContentDiv>
                <h2>관리자 로그인</h2>

                <Style.FormDiv onKeyUp={enterLoginEvent}>
                    <DefaultInput label="아이디" inputRef={idRef} placeholder="아이디를 입력해주세요." />
                    <DefaultInput label="비밀번호" type="password" inputRef={pwRef} placeholder="비밀번호를 입력해주세요." />
                </Style.FormDiv>

                <Style.BtnDiv>
                    <DefaultButton clickEvent={postLoginEvent}>로그인</DefaultButton>
                    <DefaultButton clickEvent={() => navigate("/signup/admin")} minor>회원가입</DefaultButton>
                    <Style.ControlDiv>
                        <button onClick={() => navigate("/find/admin/id")}>아이디 찾기</button>
                        <button onClick={() => navigate("/find/admin/password")}>비밀번호 찾기</button>
                    </Style.ControlDiv>
                </Style.BtnDiv>

            </Style.ContentDiv>
        </Style.Wrapper>
    )
}

export default LoginAdmin